
import { store } from '@/assets/scripts/store'

export default {
  props: {
    items: { type: Array, default: () => [] },
  },

  computed: {

    isMobile() {
      return store.isMobile
    },

    columns() {
      if (!this.items || this.items.length === 0) return null

      const modulo = this.isMobile ? 2 : 3
      const columns = Array.from({ length: modulo }, () => [])

      this.items.forEach((item, index) => {
        columns[index % modulo].push(item)
      })

      return columns
    },
  },

  methods: {
    getItemKey(item, index) {
      return 'item-' + item.id !== undefined ? item.id : index
    },
  }
}
